// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1712":"1d3628ee6b8d9163","3022":"81bbe34e255c4a51"}[chunkId] + ".js";
};